module.exports = __webpack_public_path__ + "static/media/header-optimized.7052ee91.png";